export default __webpack_public_path__ + "static/traektoria-70076cd505151afd262c297a1d683a7d.png";